import React, { useEffect } from 'react';
import { useUIStore } from 'stores';
import { usePermissions } from 'hooks/usePermissions';
import { Permissions } from 'config/permissions';
import { useSalesStore } from '../stores/salesStore';
import KanbanBoard from './leads/KanbanBoard';
import LeadModal from './leads/LeadModal';
import LeadGenerator from './leads/LeadGenerator';
import ArchivedLeads from './archived/ArchivedLeads';
import CompanyProfileEditor from './settings/CompanyProfileEditor';
import LeadExamplesManager from './settings/LeadExamplesManager';

const SalesView: React.FC = () => {
  const salesSection = useUIStore((s) => s.salesSection);
  const { hasPermission } = usePermissions();
  const { modalOpen, openLeadModal } = useSalesStore();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const leadId = params.get('lead');
    const focus = params.get('focus');
    if (leadId) {
      openLeadModal(leadId, focus === 'comment');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="h-full w-full min-w-0">
      {salesSection === 'pipeline' && <KanbanBoard />}
      {salesSection === 'archived' && <ArchivedLeads />}
      {salesSection === 'generator' && <LeadGenerator />}
      {salesSection === 'settings' && hasPermission(Permissions.SALES_SETTINGS_MANAGE) && (
        <div className="space-y-8 max-w-3xl mx-auto">
          <CompanyProfileEditor />
          <div className="border-t border-subtle pt-8">
            <LeadExamplesManager />
          </div>
        </div>
      )}

      {modalOpen && <LeadModal />}
    </div>
  );
};

export default SalesView;
